module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-32px"
  }, [_vm._v("\n    ขั้นตอนการติดตั้ง\n  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('a', {
    staticClass: "bio-button -accent -outline _mxw-256px _mgbt-64px",
    attrs: {
      "href": "https://github.com/BioMaRu/biomatic/releases/download/v0.1.4/biomatic.full.min.css.zip"
    }
  }, [_vm._v("\n    ดาวน์โหลด Biomatic\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n    หลังจากนั้น ทำการลิงค์ Biomatic ไปยังโปรเจคของคุณด้วย\n  ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n    เท่านี้คุณก็พร้อมใช้งาน Biomatic ได้ทันที 🔥🔥\n  ")]), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'Introduction'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  เกี่ยวกับ Biomatic\n      ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'GettingStart'
      }
    }
  }, [_vm._v("\n        การใช้งาน   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-64px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" การติดตั้ง\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("วิธีที่ 1")]), _vm._v(" – ติดตั้งผ่าน yarn หรือ npm วิธีนี้สะดวกสุด 👍\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('code', {
    staticClass: "_pd-12px _dp-b"
  }, [_vm._v("yarn add biomatic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('code', {
    staticClass: "_pd-12px _dp-b"
  }, [_vm._v("npm install biomatic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("วิธีที่ 2")]), _vm._v(" – ดาวโหลด Complied CSS 👌\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_c('pre', {
    staticClass: "_mgbt-64px"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<link href=\"/path/to/biomatic.css\" rel=\"stylesheet\">")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27618e68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/Installation.vue
// module id = 116
// module chunks = 0